var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4438 6.31024C20.4438 5.81934 20.0459 5.42139 19.555 5.42139H7.99969C7.50878 5.42139 7.11082 5.81934 7.11082 6.31024C7.11082 6.80114 7.50878 7.19909 7.99969 7.19909H19.555C20.0459 7.19909 20.4438 6.80114 20.4438 6.31024ZM20.4438 9.86565C20.4438 9.37475 20.0459 8.9768 19.555 8.9768H7.99969C7.50878 8.9768 7.11082 9.37475 7.11082 9.86565C7.11082 10.3566 7.50878 10.7545 7.99969 10.7545H19.555C20.0459 10.7545 20.4438 10.3566 20.4438 9.86565ZM20.4438 13.4211C20.4438 12.9302 20.0459 12.5322 19.555 12.5322H11.5552C11.0643 12.5322 10.6663 12.9302 10.6663 13.4211C10.6663 13.912 11.0643 14.3099 11.5552 14.3099H19.555C20.0459 14.3099 20.4438 13.912 20.4438 13.4211Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.999 16.977C15.999 17.4679 15.6011 17.8658 15.1102 17.8658L6.58965 17.8658L8.62773 19.9039C8.97486 20.251 8.97486 20.8138 8.62773 21.1609C8.28061 21.508 7.71781 21.508 7.37068 21.1609L3.81521 17.6055C3.46809 17.2584 3.46809 16.6956 3.81521 16.3485L7.37068 12.7931C7.71781 12.4459 8.28061 12.4459 8.62773 12.7931C8.97486 13.1402 8.97486 13.703 8.62773 14.0501L6.58965 16.0881L15.1102 16.0881C15.6011 16.0881 15.999 16.4861 15.999 16.977Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIcon);
export default __webpack_public_path__ + "static/media/navIcon.a3fd4e41440cbd2cda9a1e39269aa413.svg";
export { ForwardRef as ReactComponent };